var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pay_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#35a4dd",
    strokeWidth: 65,
    d: "M41.6 189.7h940.9v644.7H41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#35a4dd",
    strokeWidth: 120,
    d: "M41.6 360.3h940.8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 801.3,
    cy: 659.6,
    r: 69.7,
    stroke: "#f9af17",
    strokeWidth: 65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default ForwardRef;